import React from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Button, Typography, Box } from "@mui/material";
import RateReviewIcon from "@mui/icons-material/RateReview";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import BarChartIcon from "@mui/icons-material/BarChart";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import PercentIcon from "@mui/icons-material/Percent";
import SavingsIcon from "@mui/icons-material/Savings";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

const settingsOptions = [
  { label: "Reviews", icon: <RateReviewIcon />, path: "/admin/review-list" },
  {
    label: "Estimated Price",
    icon: <AttachMoneyIcon />,
    path: "/admin/estimated-price",
  },
  {
    label: "DB Health Check",
    icon: <HealthAndSafetyIcon />,
    path: "/admin/db-health-check",
  },
  {
    label: "Report",
    icon: <BarChartIcon />,
    path: "/admin/wash-summary-report",
  },
  { label: "Base Price", icon: <PriceChangeIcon />, path: "/base-price" },
  { label: "Partner Percent", icon: <PercentIcon />, path: "/partner-percent" },
  { label: "Salary", icon: <SavingsIcon />, path: "/admin/salary" },
  {
    label: "Salary List",
    icon: <ReceiptLongIcon />,
    path: "/admin/salary-list",
  },
  { label: "Earning", icon: <SavingsIcon />, path: "/earning-summary-report" },
];

const Settings = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ padding: 4 }}>
      <Typography
        variant="h4"
        gutterBottom
        sx={{ fontWeight: "bold", textAlign: "center" }}
      >
        Settings
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {settingsOptions.map((option, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Button
              fullWidth
              variant="contained"
              onClick={() => navigate(option.path)}
              startIcon={option.icon}
              sx={{
                padding: 2,
                height: 80,
                justifyContent: "flex-start",
                borderRadius: 3,
                backgroundColor: "#1976d2",
                color: "#fff",
                boxShadow: 3,
                "&:hover": {
                  backgroundColor: "#1565c0",
                },
              }}
            >
              <Typography variant="h6" sx={{ marginLeft: 1 }}>
                {option.label}
              </Typography>
            </Button>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Settings;
